module.exports = __webpack_public_path__ + "static/media/Trails-of-Loon-Lake-Bylaws.c861bb89.pdf";